import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component - scrolls to top of page on route change
 * Add this component inside your Router but outside of Routes
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth" // For smooth scrolling, use "auto" for instant jump
    });
  }, [pathname]);

  return null; // This component doesn't render anything
}

export default ScrollToTop;
